import { render, staticRenderFns } from "./NewTempAccount.vue?vue&type=template&id=1b4c5750"
import script from "./NewTempAccount.vue?vue&type=script&lang=js"
export * from "./NewTempAccount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports